import { createContext, useContext } from "react";
import { useStore } from "zustand/index";
import { useShallow } from "zustand/react/shallow";

import { WorkflowContextType, WorkflowStoreType } from "./workflow_store_types";

export const WorkflowStoreContext = createContext<WorkflowContextType>({} as WorkflowContextType);

export const useWorkflowStore = <U>(selector: (state: WorkflowStoreType) => U) => {
  const store = useContext(WorkflowStoreContext);

  return useStore(store, useShallow(selector));
};

export const useWorkflowStoreActions = () => {
  const store = useContext(WorkflowStoreContext);

  return useStore(store, (state) => state.actions);
};
